var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAutofillIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 8.76196L17.3333 11.762L22 5.76196",
    stroke: "#4FC0CF",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.83259 11.4314C4.93422 11.152 3.40198 9.58656 3.1265 8.66659C2.61948 6.9733 2.97696 5.62351 4.27051 4.34704C5.56407 3.07075 6.93212 2.71804 8.6485 3.2183C9.65377 3.51141 11.1703 5.00767 11.4673 5.99951C11.9744 7.69298 11.6169 9.04278 10.3233 10.3191C9.03527 11.5898 7.53616 11.9611 5.83259 11.4314ZM0.0572078 19.5985C-0.109726 19.3321 0.110107 17.4913 0.439582 16.3967C0.584917 15.9141 0.955027 15.1769 1.26217 14.7585C1.88817 13.906 3.31205 12.9315 3.9322 12.9315C4.15624 12.9315 5.00501 13.2682 5.81826 13.6796L7.29687 14.4274L8.77548 13.6796C9.58874 13.2682 10.4375 12.9315 10.6614 12.9315C11.2828 12.9315 12.7059 13.9066 13.3345 14.7626C14.0297 15.7093 14.4542 17.1052 14.4955 18.5797L14.527 19.704L7.35471 19.7513C2.25938 19.7847 0.146166 19.7405 0.0572078 19.5985Z",
    fill: "#4FC0CF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutofillIcon);
export default __webpack_public_path__ + "static/media/autofill-icon.895093bd6ab081f3771d2a3e2ea095df.svg";
export { ForwardRef as ReactComponent };